import { render, staticRenderFns } from "./kpVariantSifter.vue?vue&type=template&id=036fdcf1&scoped=true&"
import script from "./kpVariantSifter.vue?vue&type=script&lang=js&"
export * from "./kpVariantSifter.vue?vue&type=script&lang=js&"
import style0 from "./kpVariantSifter.vue?vue&type=style&index=0&id=036fdcf1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036fdcf1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Portal (Dev)/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('036fdcf1')) {
      api.createRecord('036fdcf1', component.options)
    } else {
      api.reload('036fdcf1', component.options)
    }
    module.hot.accept("./kpVariantSifter.vue?vue&type=template&id=036fdcf1&scoped=true&", function () {
      api.rerender('036fdcf1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/kpVariantSifter.vue"
export default component.exports